import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { Viewer } from "../../../../../widgets/Viewer";
import { withRouter } from 'react-router-dom';
import { Spinner } from '@blueprintjs/core';

import { loadRecipientMiscDocs, deleteRecipientMiscDoc } from '../../../../../../redux/actions/recipientMiscDoc.actions';

const RecipientMiscDocRow = props => {
    return (
        <tr onClick={() => props.editRow(props.recipientMiscDoc)}>
            <td>{moment(props.recipientMiscDoc.created_at).format('ddd, MMM Do, YYYY')}</td>
            <td>{props.recipientMiscDoc.notes}</td>
            <td onClick={e => e.stopPropagation()}>
                <Viewer src={props.recipientMiscDoc.image || props.recipientMiscDoc.dropbox_image_share_url || ''} style={{ height: '30px' }} thumbnail />
            </td>
            <td className="action-row">
                <div className="pt-button pt-intent-danger pt-icon-trash pt-small" onClick={(event) => props.deleteRow({ recipientMiscDoc: props.recipientMiscDoc, event })}>Delete</div>
            </td>
        </tr>
    );
};

class RecipientMiscDocs extends Component {
    async componentDidMount() {
        const { clientId, progressId } = this.props.match.params;
        await this.props.loadRecipientMiscDocs({ recipientId: clientId, progressId });
    }
    openRecipientMiscDocsModal = () => {
        const event = new CustomEvent('open-recipient-misc-doc-modal', {
            detail: {
                ...this.props.match.params,
                recipientId: this.props.match.params.clientId
            }
        });
        window.dispatchEvent(event);
    }
    editRow = (recipientMiscDoc) => {
        const { clientId, progressId } = this.props.match.params;
        const event = new CustomEvent('open-recipient-misc-doc-modal', {
            detail: {
                ...recipientMiscDoc,
                recipientId: clientId,
                progressId
            }
        });
        window.dispatchEvent(event);
    }
    deleteRow = ({ event, recipientMiscDoc }) => {
        event.preventDefault();
        event.stopPropagation();
        const { clientId, progressId } = this.props.match.params;
        const customEvent = new CustomEvent('open-delete-modal', {
            detail: {
                content: `Are you sure you want to delete this document?`,
                onDelete: () => {
                    this.props.deleteRecipientMiscDoc({ recipientId: clientId, progressId, docId: recipientMiscDoc.id });
                }
            }
        });
        window.dispatchEvent(customEvent);
    }
    render() {
        const { recipientMiscDocs } = this.props;
        return (
            <div className="panel-recipientMiscDocs panel-content">
                { this.props.allLoading ?
                    <div className="spinner-container">
                        <Spinner large />
                    </div> :
                    recipientMiscDocs.length ?
                        <table className="general-table pt-html-table pt-interactive">
                            <thead>
                                <tr>
                                    <th>Date Added</th>
                                    <th>Notes</th>
                                    <th>Preview</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                { recipientMiscDocs.map((recipientMiscDoc, i) => (
                                    <RecipientMiscDocRow key={i}
                                        recipientMiscDoc={recipientMiscDoc}
                                        editRow={this.editRow}
                                        deleteRow={this.deleteRow} />
                                ))}
                            </tbody>
                        </table> :
                        <div className="intro">
                            <div className="intro-text">
                                No documents. Start by <span className="link" onClick={this.openRecipientMiscDocsModal} >adding one</span>
                            </div>
                        </div>
                }
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => ({
    recipientMiscDocs: state.recipientMiscDoc.recipientMiscDocs,
    recipientMiscDocsById: state.recipientMiscDoc.recipientMiscDocsById,
    allLoading: state.recipientMiscDoc.allLoading
});

const mapDispatchToProps = {
    loadRecipientMiscDocs,
    deleteRecipientMiscDoc
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(RecipientMiscDocs));


// WEBPACK FOOTER //
// ./src/components/main/dashboard/panel/recipient/progress-panels/RecipientMiscDocs.jsx